var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',{staticClass:"header"},[_vm._v("Выводы:")]),_c('table',[_c('tr',[_c('td',{staticClass:"label"},[_vm._v("Рекомендация(расчёт)")]),_c('td',{staticClass:"value"},[_vm._v(_vm._s(_vm.recommendation))])])])])}
var staticRenderFns = []

export { render, staticRenderFns }